import { Button, Chip } from '@mui/material';

import { PORTAL_ROLES } from '../config/roles';
import useAuthChecker from '../hooks/useAuthChecker';
import { useTagsSelector } from '../hooks/useTagsSelector';
import type { SurveyMeta, SurveyTag } from '../types/survey';

const TagsTableCell = ({ cell }) => {
  const { open: openTagsSelector, removeTag } = useTagsSelector();

  const { isAuthed: canChangeTags } = useAuthChecker({
    atLeast: PORTAL_ROLES.LEAD_SURVEYOR,
    allowList: [PORTAL_ROLES.QUALITY_ASSURANCE],
  });

  const surveyMeta = cell.row.original as SurveyMeta;
  const surveyId = surveyMeta?.id;
  const tags = surveyMeta?.surveyTags || [];

  function showSelectorDialog() {
    openTagsSelector({
      selectedTags: tags,
      id: surveyId,
    });
  }

  function onClickedRemove(tag: SurveyTag) {
    removeTag(tag, tags, surveyId);
  }

  return tags.length ? (
    tags.map((tag) => (
      <Chip
        disabled={!canChangeTags}
        label={tag.label}
        key={tag.id}
        sx={{ mr: 1 }}
        color="primary"
        onClick={
          canChangeTags
            ? (event) => {
                event.stopPropagation();
                showSelectorDialog();
              }
            : undefined
        }
        onDelete={
          canChangeTags
            ? () => {
                onClickedRemove(tag);
              }
            : undefined
        }
      />
    ))
  ) : (
    <Button
      disabled={!canChangeTags}
      variant="text"
      sx={{
        opacity: 0,
        '&:hover': {
          opacity: 1,
        },
      }}
      onClick={(event) => {
        event.stopPropagation();
        showSelectorDialog();
      }}
    >
      Add Tag
    </Button>
  );
};

export default TagsTableCell;
